import { CS_EVOLVE_PRODUCT_TYPE_KEY, EAB_EVOLVE_PRODUCT_TYPE_KEY, EAQ_ISBN, SAFE_MED_PRODUCT_TYPE_KEY } from 'constants/app.constant';
import { EvolveProductTypeKey } from 'constants/externalApp.constant';
import { facadeApi, perFacadeApi } from 'helpers/api.helper';
export var fetchCourses = function (email) {
    if (email === null) {
        return [];
    }
    return facadeApi.get("v1/eolsUser/list/byEmail/".concat(email), {});
};
export var fetchCourseSectionInfo = function (courseId) {
    if (courseId) {
        return perFacadeApi.get("/courseSections/".concat(courseId));
    }
    return Promise.resolve({ data: {} });
};
export var fetchCourseStudents = function (courseId) {
    return perFacadeApi.get("/courseSections/".concat(courseId, "/students"));
};
export var getEAQIsbnFromCourseSection = function (courseSectionInfo) {
    var _a;
    return (_a = ((courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.entitlements) || []).find(function (e) { return e.type === EAQ_ISBN; })) === null || _a === void 0 ? void 0 : _a.isbn;
};
var isProductByCourseSection = function (courseSectionInfo, productTypeKey) {
    return ((courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.entitlements) || []).every(function (e) { return e.evolveProductTypeKey === productTypeKey; });
};
export var isEABAppByCourseSection = function (courseSectionInfo) {
    return isProductByCourseSection(courseSectionInfo, EAB_EVOLVE_PRODUCT_TYPE_KEY);
};
export var isCSAppByCourseSection = function (courseSectionInfo) {
    return isProductByCourseSection(courseSectionInfo, CS_EVOLVE_PRODUCT_TYPE_KEY);
};
export var isEAQStandalone = function (courseSectionInfo) {
    var entitlements = (courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.entitlements) || [];
    if (!entitlements.length)
        return false;
    return entitlements.every(function (e) { return e.evolveProductTypeKey === EvolveProductTypeKey.EAQNG_IA || e.evolveProductTypeKey === EvolveProductTypeKey.EAQ_IA; });
};
export var fetchCourseQuestionSets = function (userId, courseId) {
    return perFacadeApi.get("/eolsUser/".concat(userId, "/courseSection/").concat(courseId, "/questionSets"));
};
export var fetchEAQAssessmentMastery = function (isbn, courseId, topicOrgId, userId) {
    var params = new URLSearchParams();
    if (userId)
        params.append('userId', String(userId));
    if (topicOrgId)
        params.append('topicOrgId', topicOrgId);
    var query = params.toString() ? "?".concat(params) : '';
    return perFacadeApi.get("/ehr/assessment/mastery/".concat(isbn, "/").concat(courseId).concat(query));
};
export var isSafeMedCourseByCourseSection = function (courseSectionInfo) {
    return ((courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.entitlements) || []).some(function (e) { return e.evolveProductTypeKey === SAFE_MED_PRODUCT_TYPE_KEY; });
};
export var fetchEAQTaxonomies = function (isbn) {
    return facadeApi.get("/eaq/recommender/isbn/".concat(isbn, "/taxonomies"));
};
